import styled from 'styled-components';

import HiringMeetingAttendeeSelectInput from '../../../../../library/inputs/HiringMeetingAttendeeSelectInput';

export const StyledHiringMeetingAttendeeSelectInput = styled(HiringMeetingAttendeeSelectInput)`
  /* Needs to be > 1 to be on top of other select input icons (since the icon has a z-index of 1). */
  z-index: 2;
`;
